/*
 * @Author: Jiajia Li
 * @Date: 2024-08-27 09:23:00
 * @LastEditTime: 2024-10-01 16:36:48
 * @Description:
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./custom.scss";

import { HelmetProvider } from 'react-helmet-async';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId="323598825766-rmdoblfndaltlq9tsm6r6dq25354nb0k.apps.googleusercontent.com">
    <HelmetProvider>
     <App/>
    </HelmetProvider>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);

reportWebVitals();
